import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { useDeleteCartItemMutation, useGetCartQuery } from '@/redux/api/client/cart';
import { CartViewModel, OrderLineViewModel } from '@/@types/client-api';
import { closeCartPanel } from '@/redux/slices/cartSlice';

interface UseCartReturn {
  cartData: CartViewModel | undefined;
  isLoading: boolean;
  subTotal: string;
  checkout: {
    buttonProps: {
      label: string;
      href: string;
      onClick?: () => void;
    };
  };
  deleteCartItem: (code: string) => void;
}

export const useCart = (): UseCartReturn => {
  const dispatch = useDispatch();
  const siteLabels = useSelector((state: RootState) => state.page.siteLabels);
  const { data: cartData, isLoading } = useGetCartQuery();
  const [deleteCartItem] = useDeleteCartItemMutation();

  const formatSubTotal = (): string => {
    if (cartData?.hasErrors) return '--';

    return cartData?.subTotal?.toFixed(2) || '0.00';
  };

  const handleCheckout = () => {
    dispatch(closeCartPanel());
  };

  const handleDeleteCartItem = (code: string) => {
    const request: OrderLineViewModel[] = [{ code: code }];
    deleteCartItem(request);
  };

  const checkoutButtonProps = {
    label: 'Checkout',
    href: siteLabels?.checkoutPageReference?.url || '',
    color: 'black',
    onClick: handleCheckout
  };

  return {
    cartData,
    isLoading,
    subTotal: formatSubTotal(),
    checkout: {
      buttonProps: checkoutButtonProps
    },
    deleteCartItem: handleDeleteCartItem
  };
};
